"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _tinymce = _interopRequireDefault(require("tinymce"));

// Ported from https://github.com/tinymce/tinymce/blob/4.9.2/src/ui/main/ts/WindowManagerImpl.ts
var _tinymce$ui = _tinymce.default.ui,
    Window = _tinymce$ui.Window,
    MessageBox = _tinymce$ui.MessageBox;

function _default() {
  var open = function open(args, params, closeCallback) {
    var win;
    args.title = args.title || ' '; // Handle URL

    args.url = args.url || args.file; // Legacy

    if (args.url) {
      args.width = parseInt(args.width || 320, 10);
      args.height = parseInt(args.height || 240, 10);
    } // Handle body


    if (args.body) {
      args.items = {
        defaults: args.defaults,
        type: args.bodyType || 'form',
        items: args.body,
        data: args.data,
        callbacks: args.commands
      };
    }

    if (!args.url && !args.buttons) {
      args.buttons = [{
        text: 'Ok',
        subtype: 'primary',
        onclick: function onclick() {
          win.find('form')[0].submit();
        }
      }, {
        text: 'Cancel',
        onclick: function onclick() {
          win.close();
        }
      }];
    }

    win = new Window(args);
    win.on('close', function () {
      closeCallback(win);
    }); // Handle data

    if (args.data) {
      win.on('postRender', function () {
        this.find('*').each(function (ctrl) {
          var name = ctrl.name();

          if (name in args.data) {
            ctrl.value(args.data[name]);
          }
        });
      });
    } // store args and parameters


    win.features = args || {};
    win.params = params || {}; // Always render dialogs into the body since webkit would scroll ui containers
    // if you open a fixed container and move focus to an input within that container

    win = win.renderTo(document.body).reflow();
    return win;
  };

  var alert = function alert(message, choiceCallback, closeCallback) {
    var win = MessageBox.alert(message, function () {
      choiceCallback();
    });
    win.on('close', function () {
      closeCallback(win);
    });
    return win;
  };

  var confirm = function confirm(message, choiceCallback, closeCallback) {
    var win = MessageBox.confirm(message, function (state) {
      choiceCallback(state);
    });
    win.on('close', function () {
      closeCallback(win);
    });
    return win;
  };

  var close = function close(window) {
    window.close();
  };

  var getParams = function getParams(window) {
    return window.params;
  };

  var setParams = function setParams(window, params) {
    window.params = params;
  };

  return {
    open: open,
    alert: alert,
    confirm: confirm,
    close: close,
    getParams: getParams,
    setParams: setParams
  };
}

module.exports = exports.default;